import { render } from "./VsDivider.vue?vue&type=template&id=32ab34de"
import script from "./VsDivider.vue?vue&type=script&lang=js"
export * from "./VsDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__